import axios from "axios";
import { useState } from "react";
import { fetchData } from "../store/config";

interface Props {
    name: string
}
interface TypeResponse{
    status: string
    img: string
    pdf: string
    data:{
      pdf: string
      img: string
    }
}

interface TypeQuery{
    url: string
    params: Object
}
const useQueryDowload = ({name}:Props) => {
    const [isLoading, setIsLoading] = useState<boolean>(false)
/*     const [data, setData] = useState<TypeResponse | null>(null) */
    const [error, setError] = useState<any>(null)

    const onGenerate = ({url,params}:TypeQuery) =>{
      console.log(url)
      setIsLoading(true)
      fetchData().get<TypeResponse>(url, {
        params:{
          ...params
        }
      })
      .then(res => {
        // console.log(res)
        if(res.data.img && res.data.pdf) {
          onDownload(res.data.pdf)
        }else if(res.data.img){
          onDownload(res.data.img)
        }
        else if(res.data.data.pdf){
          onDownload(res.data.data.pdf)
        }else if(res.data.data.img){
          onDownload(res.data.data.img)
        }
      })
      .catch((err) => {
        setIsLoading(false)
        setError(err)
      })
    }
    const onGeneratePost = ({url,params}:TypeQuery) =>{
      setIsLoading(true)
      fetchData().post(url, {
        ...params
      })
      .then(res => {
        console.log(res)
        if(res.data.img && res.data.pdf) {
          onDownload(res.data.pdf)
        }else if(res.data.img){
          onDownload(res.data.img)
        }
        else if(res.data.data.pdf){
          onDownload(res.data.data.pdf)
        }else if(res.data.data.img){
          onDownload(res.data.data.img)
        }
      })
      .catch((err) => {
        setIsLoading(false)
        setError(err)
      })
    }

    const onDownload =(url: string) =>{
        axios({
          url,
          method:'GET',
          responseType: 'blob'
        })
        .then((response)=>{
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url;
          link.setAttribute('download', name)
            document.body.appendChild(link)
            link.click()
            setIsLoading(false)
        })
        .catch(()=>{
            setIsLoading(false)
        })
    }
    return{isLoading,onGenerate, onDownload, setIsLoading, onGeneratePost}
}

export default useQueryDowload